const isAnyFieldModified = (defaultValues, formValues) =>
  Object.keys(formValues).some((key) => formValues[key] !== defaultValues[key])

export default { isAnyFieldModified }
